<template>
 <OnlyOnClient>
   <div class="back_modal_full" v-if="!isCitySelected">
     <div class="container">
       <div class="start__page">
         <img src="/assets/img/start.png" alt="">
       </div>
     </div>
   </div>
   <TheModal class="modal-stop"  v-model:show="showModal">
     <div class="city__body modal__body full">
       <div v-if="isCitySelected" @click="setShowCityModal(false)"  class="modal__close">
         <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path d="M5.33333 5.33398L26.6667 26.6673M26.6667 5.33398L5.33333 26.6673" stroke="white" stroke-width="2"
                 stroke-linecap="round" stroke-linejoin="round" />
         </svg>
       </div>
       <div class="city__row">
         <div class="city__logo"> <img src="/assets/img/modal-logo.png" alt=""></div>
         <div class="city__title">Выбор города</div>
         <div @click="setShowCityModal(false)" class="modal__close  start-page"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                   xmlns="http://www.w3.org/2000/svg">
           <path d="M4 4L20 20M20 4L4 20" stroke="black" stroke-width="2" stroke-linecap="round"
                 stroke-linejoin="round" />
         </svg>
         </div>
       </div>
       <div class="city__body-search field__input">
         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path
               d="M15.7955 15.8111L21 21M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z"
               stroke="#808183" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
         </svg>
         <input v-model="search" type="text" placeholder="Ваш город">
         <div class="clear">
           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path
                 d="M9.33333 9.33333L14.6667 14.6667M14.6667 9.33333L9.33333 14.6667M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                 stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
           </svg>
         </div>
       </div>
       <ul class="city__list">
         <li v-for="city in filteredCities">
           <a v-if="city.name.includes(search)"  :href="city.url">{{ city.name }}</a>
         </li>
       </ul>
     </div>
   </TheModal>
 </OnlyOnClient>

</template>

<script>
import TheModal from "@/components/TheModal.vue";
import {mapGetters, mapMutations, mapState} from "vuex";
import OnlyOnClient from "@/components/OnlyOnClient.vue";
export default {
  name: 'TheCityModal',
  components: {OnlyOnClient, TheModal},
  data() {
    return {
      search: '',
    }
  },
  computed:{
    showModal: {
      get() {
        return this.showCityModal;
      },
      set(value) {
        this.setShowCityModal(value)
      }
    },
    filteredCities() {
      return this.cities.filter(
          city => city.name.includes(this.search) && !city.on_testing
      );
    },
    ...mapState({
      'showCityModal': state => state.city.showCityModal,
      'cities': state => state.city.cities,
      'city_id': state => state.city.city_id,
    }),
    ...mapGetters({
      'isCitySelected': 'city/isCitySelected',
    }),
  },
  methods:{
    ...mapMutations({
      'setShowCityModal': 'city/setShowCityModal',
      'setCityId': 'city/setCityId',
    }),
  },
}
</script>

<style lang="css" scoped>
    .back_modal_full{
      position: absolute;
      width: 100%;
      height: 100vh;
      top: 0;
      background: white;
    }
</style>